import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactModal from 'react-modal'

import ActionButton from '../../../../components/ui/ActionButton/ActionButton'

const StyledReactModal = styled(ReactModal)`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }
`
const ModalContent = styled.div`
  position: relative;
  padding: 1rem;
  margin: 0 auto;
  width: 325px;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
`
const Title = styled.h2`
  color: var(--color-secondary);
  font-size: 1.375rem;
  font-weight: var(--font-weight-bold);
  text-align: center;
  margin: 0;
  margin-bottom: 0.625rem;
`
const Description = styled.p`
  font-size: 0.875rem;
  line-height: 1.375rem;
  text-align: center;
  margin: 0;
  margin-bottom: 1.5rem;
`
const ActionButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`
const StyledActionButton = styled(ActionButton)`
  width: 48%;
`

const overlay = {
  zIndex: 10005,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

const ErrorModal = ({ show, onConfirmClick, onCancelClick }) => {
  return (
    <StyledReactModal
      isOpen={show}
      style={{ overlay, content }}
      closeTimeoutMS={150}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
    >
      <ModalContent>
        <Title>Something's not right</Title>
        <Description>Please try logging in.</Description>
        <ActionButtonContainer>
          <div />
          <StyledActionButton
            small
            variant="secondary"
            onClick={onConfirmClick}
          >
            Login
          </StyledActionButton>
        </ActionButtonContainer>
      </ModalContent>
    </StyledReactModal>
  )
}

ErrorModal.defaultProps = {
  show: false,
  onConfirmClick: () => {},
  onCancelClick: () => {},
}

ErrorModal.propTypes = {
  show: PropTypes.bool,
  onConfirmClick: PropTypes.func,
  onCancelClick: PropTypes.func,
}

export default ErrorModal
